<template>
  <div class="row">
    <div class="col-12">
      <div class="mt-4">
        <input
          type="text"
          class="form-control form-control-sm mb-3"
          v-model="services.childService.name"
          placeholder="Sub-Service Name"
        />
        <div class="mb-3">
          <div
            class="custom-control custom-checkbox"
            v-for="(opt, key) in services.availableOptions"
            :key="key"
          >
            <input
              class="custom-control-input"
              type="checkbox"
              :id="`check-${opt.toLowerCase()}`"
              name="opt[]"
              v-bind:value="opt"
              @change="checkedOption(opt)"
              :checked="optionChecked(opt)"
            />
            <label
              class="custom-control-label"
              :for="`check-${opt.toLowerCase()}`"
              >{{ opt }}</label
            >
          </div>
        </div>
        <br />
        <button
          class="btn btn-sm btn-outline-primary mr-2"
          @click="addChildService"
          :disabled="child.name == `` ? true : false"
        >
          <span v-if="!saving && child.type == 'creating'"
            ><icon type="save"></icon> Save Sub-Service</span
          >
          <span v-if="!saving && child.type == 'editing'"
            ><icon type="save"></icon> Update Sub-Service</span
          >
          <span
            class="spinner-border spinner-border-sm my-2"
            v-if="saving"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
        <button
          class="btn btn-sm btn-danger mr-2 my-2"
          @click="deleteChildService"
          :disabled="deleting"
          v-if="child.type == 'editing'"
        >
          <span v-if="!deleting"
            ><icon type="trash"></icon> Delete Sub-Service</span
          >
          <span
            class="spinner-border spinner-border-sm"
            v-if="deleting"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
        <button class="btn btn-sm btn-secondary my-2" @click="cancelEditing">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "SubServiceForm",
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    ...mapState(["saving", "services"]),
    child: function () {
      return this.services.childService;
    },
  },
  methods: {
    addChildService: function () {
      if (this.services.child != "") {
        this.$store.commit("SET_SAVING_STATE", true, { root: true });
        this.$store.dispatch(
          "services/saveChildService",
          this.services.childService
        );
      }
    },
    cancelEditing: function () {
      this.services.childService.name = this.services.tmp;
      this.$store.commit("services/CANCEL_EDITING");
    },
    optionChecked: function (opt) {
      if (this.services.childService.options) {
        return this.services.childService.options.includes(opt) ? true : false;
      }
      return false;
    },
    checkedOption: function (opt) {
      if (this.services.childService.options.includes(opt)) {
        this.services.childService.options.splice(
          this.services.childService.options.indexOf(opt),
          1
        );
      } else {
        this.services.childService.options.push(opt);
      }
    },
    deleteChildService: function () {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            this.deleting = true;
            this.$store
              .dispatch(
                "services/deleteChildService",
                this.services.childService
              )
              .then(() => {
                this.deleting = false;
              });
          }
        });
    },
  },
};
</script>
